<template>
  <v-footer class="footer-root pa-0" style="width:100%;max-width:100%;">
    <!-- ── Main footer body ──────────────────────────────────────── -->
    <div class="footer-body">
      <v-container fluid class="py-10 px-6 px-md-12">
        <v-row>
          <!-- Brand -->
          <v-col cols="12" sm="6" md="3">
            <v-img src="../assets/gckLogo1.png" height="80" width="80" contain class="mb-3" />
            <div class="footer-college-name">Government College Karauli</div>
            <div class="footer-tagline">Established 1960 · Affiliated to University of Kota</div>
            <div class="footer-tagline mt-1">Near Circuit House, Kailadevi Road,<br>Karauli – 322241, Rajasthan</div>
            <v-btn
              icon size="small" variant="tonal" color="#FFD740"
              class="mt-3"
              href="https://www.facebook.com/Karauli.college/" target="_blank"
            >
              <v-icon>mdi-facebook</v-icon>
            </v-btn>
          </v-col>

          <!-- Quick links -->
          <v-col cols="6" sm="6" md="2">
            <div class="footer-section-title">Quick Links</div>
            <div class="footer-divider mb-3"></div>
            <ul class="footer-links">
              <li><a href="/circular">Circulars</a></li>
              <li><a href="/events">Events</a></li>
              <li><a href="/scholarships">Scholarships</a></li>
              <li><a href="/departments">Departments</a></li>
              <li><a href="/iqac_all">IQAC</a></li>
              <li><a href="/naac">NAAC</a></li>
              <li><a href="https://api.govtcollegekarauli.ac.in/storage/959/PM-USHA-Text.pdf" target="_blank">PM USHA</a></li>
            </ul>
          </v-col>

          <!-- Admissions -->
          <v-col cols="6" sm="6" md="2">
            <div class="footer-section-title">Admissions</div>
            <div class="footer-divider mb-3"></div>
            <ul class="footer-links">
              <li><a href="/admissions">Admissions Info</a></li>
              <li><a href="/courses_offered">Courses Offered</a></li>
              <li><a href="https://dceapp.rajasthan.gov.in/" target="_blank">Admission Portal</a></li>
              <li><a href="/practical_fee">Practical Fee</a></li>
            </ul>
          </v-col>

          <!-- Nodal Officer -->
          <v-col cols="12" sm="6" md="2">
            <div class="footer-section-title">Nodal Officer</div>
            <div class="footer-divider mb-3"></div>
            <p class="footer-contact-text">Sh. Vishram Singh Meena</p>
            <p class="footer-contact-text">Assistant Professor</p>
            <p class="footer-contact-text mt-2">
              <v-icon size="14" class="mr-1">mdi-phone</v-icon>+91 8562085430
            </p>
            <p class="footer-contact-text">
              <v-icon size="14" class="mr-1">mdi-fax</v-icon>07464-250023
            </p>
            <p class="footer-contact-text">
              <v-icon size="14" class="mr-1">mdi-email-outline</v-icon>
              <span style="word-break:break-all;">meenavishramsingh1986@gmail.com</span>
            </p>
          </v-col>

          <!-- Map -->
          <v-col cols="12" sm="6" md="3">
            <div class="footer-section-title">Find Us</div>
            <div class="footer-divider mb-3"></div>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d14282.468612936627!2d77.01561!3d26.500269!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDMwJzAxLjAiTiA3N8KwMDAnNTYuMiJF!5e0!3m2!1sen!2sus!4v1706955217743!5m2!1sen!2sus"
              width="100%" height="160" style="border:0;border-radius:8px;" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- ── Bottom bar ──────────────────────────────────────────────── -->
    <div class="footer-bottom">
      <v-container fluid class="px-6 px-md-12">
        <div class="d-flex flex-wrap justify-space-between align-center py-3 gap-2">
          <span>© {{ new Date().getFullYear() }} Government College Karauli. All Rights Reserved.</span>
          <span>
            <a href="/rti" class="footer-bottom-link">RTI</a>
            &nbsp;·&nbsp;
            <a href="/contact" class="footer-bottom-link">Contact</a>
          </span>
        </div>
      </v-container>
    </div>
  </v-footer>
</template>

<style scoped>
.footer-root {
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0;
}

.footer-body  { background: #1A237E; color: #CFD8DC; width: 100%; }
.footer-bottom { background: #111B6E; color: #90A4AE; font-size: 0.78rem; width: 100%; }

.footer-college-name {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.3;
}
.footer-tagline { font-size: 0.75rem; color: #90A4AE; margin-top: 4px; line-height: 1.5; }

.footer-section-title {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #FFD740;
}
.footer-divider { height: 2px; width: 32px; background: #F57C00; border-radius: 2px; }

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.footer-links a {
  color: #C5CAE9;
  text-decoration: none;
  font-size: 0.82rem;
  transition: color 0.15s;
}
.footer-links a:hover { color: #FFD740; }

.footer-contact-text { font-size: 0.8rem; color: #C5CAE9; margin: 3px 0; line-height: 1.5; }

.footer-bottom-link { color: #90A4AE; text-decoration: none; }
.footer-bottom-link:hover { color: #FFD740; }
</style>
